import { useCallback, useState } from 'react';

import type { FolderNode } from '../../types/fileSystem.js';
import type { RagTableType } from '../../types/rag.js';

type Target = { documents: RagTableType[]; folders: FolderNode[] };

const NOTHING: Target = { documents: [], folders: [] };

export const useDeleteNodesDialog = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [target, setTarget] = useState<Target>(NOTHING);

  const open = useCallback(
    (documents: RagTableType[], folders: FolderNode[] = []) => {
      setTarget({ documents, folders });
      setIsOpen(true);
    },
    [],
  );

  const close = useCallback(() => setIsOpen(false), []);

  return { isOpen, ...target, open, close };
};
